import { Children, useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { carMakeState, carModelState } from '../../Checkout/atoms';

export type DrawerProps = React.HTMLAttributes<HTMLOrSVGElement> & {
	isActive: boolean;
	expandDuration?: number;
	tag?: keyof JSX.IntrinsicElements;
	showOverflow?: boolean;
	noThrottle?: boolean;
	overflowWhenShown?: string;
};

export const Drawer: React.FC<DrawerProps> = ({
	children,
	tag: Tag = 'div',
	isActive,
	expandDuration = 200,
	showOverflow,
	noThrottle = false,
	overflowWhenShown = 'auto',
	className,
	...props
}) => {
	const [contentHeight, setContentHeight] = useState(0);
	const ref = useRef<HTMLDivElement>(null);

	const active = noThrottle ? isActive : noThrottle;
	const [make] = useRecoilState(carMakeState);

	const [model] = useRecoilState(carModelState);

	useEffect(() => {
		let height = 100;
		if (make) height = 180;
		if (model) height = 240;
		if (ref) {
			const elheight = ref.current?.clientHeight
				? ref.current?.clientHeight
				: height;
			if (elheight > height) height = elheight;
		}
		setContentHeight(height);
	}, [ref, active, make, model]);

	const [header, others] = Children.toArray(children);
	const expand = isActive ? `${contentHeight}px` : '0px';

	return (
		<Tag
			className={`drawer${className ? ` ${className}` : ''}`}
			{...props}
			style={{
				...props.style,
				overflow: showOverflow ? overflowWhenShown : 'hidden',
				paddingBottom: 0,
				margin: '0 -16px 16px -16px'
			}}
		>
			{header}

			<div
				style={{
					overflowY: active ? 'visible' : 'hidden',
					padding: '0 16px',
					height: expand,
					transition: 'height 1s ease'
				}}
			>
				<div ref={ref}>{others}</div>
			</div>
		</Tag>
	);
};
